import { Box, Container } from "theme-ui"

const Cta = ({ children }) => (
  <Box as="section" sx={{ backgroundColor: "background.dark2x" }}>
    <Container py={"80px"}>{children}</Container>
  </Box>
)

export default Cta
